import { supabase } from "@/integrations/supabase/client";

const BUCKET = "profile-pictures";

export const MAX_PROFILE_PHOTO_BYTES = 5 * 1024 * 1024;

/** A rejection the user can fix (wrong type, too large) — safe to show verbatim. */
export class PhotoUploadError extends Error {}

/**
 * Uploads one image to the private profile-pictures bucket and returns its
 * storage PATH (not a URL — the bucket is private; reads mint signed URLs via
 * @/lib/photoUrl). Shared by the signup wizard (Step1BasicInfo) and the
 * backfill dialog so there is one upload mechanism, not two.
 */
export async function uploadProfilePhoto(
  file: File,
  prefix = "profile",
): Promise<string> {
  if (!file.type.startsWith("image/")) {
    throw new PhotoUploadError("Please upload an image file");
  }
  if (file.size > MAX_PROFILE_PHOTO_BYTES) {
    throw new PhotoUploadError("Image size should be less than 5MB");
  }

  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) throw new Error("Not authenticated");

  const fileExt = file.name.split(".").pop();
  const fileName = `${user.id}/${prefix}_${Date.now()}.${fileExt}`;

  const { error } = await supabase.storage
    .from(BUCKET)
    .upload(fileName, file, { upsert: true });
  if (error) throw error;

  return fileName;
}
